<template>
  <div>
    <div v-if="loading">
      <el-loading :fullscreen="true">数据加载中...</el-loading>
    </div>
    <div class="flex flex-col">
      <div class="grid items-center grid-cols-2">
        <div class="text-xl font-bold">在线课程</div>
        <div class="flex flex-row justify-end text-sm text-gray-400">
          <div class="cursor-pointer hover:text-red-500" @click="routeToMoreClass">
            <span>更多 >> </span>
          </div>
        </div>
      </div>

      <div v-if="classInfoArray.length > 0" class="grid grid-cols-2 mt-3 lg:gap-5 md:gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
        <div v-for="(value, index) in classInfoArray" :key="value.id">
          <!-- <TestMessageVue :message="value"/> -->

          <ShowClassCardVue :obj-data="value"></ShowClassCardVue>
        </div>
      </div>

      <div v-else class="flex flex-col items-center justify-center">
        <el-empty description="课程内容为空" image="/img/empty.png" :image-size="44" />
        <el-button type="primary" size="small" @click="refreshWindowLocation">刷新</el-button>
      </div>
    </div>
    <div class="flex flex-col pb-5 mt-6">
      <div class="grid items-center grid-cols-2">
        <div class="text-xl font-bold">作品展示</div>
        <div class="flex flex-row justify-end text-sm text-gray-400">
          <div class="cursor-pointer hover:text-red-500" @click="routeToMoreWork">
            <span>更多 >></span>
          </div>
        </div>
      </div>

      <!-- <div v-if="workInfoArray.length == 0 || workInfoArray == null || workInfoArray == undefined">
                <el-empty description="作品内容为空" />
            </div> -->

      <div v-if="workInfoArray.length > 0" class="grid grid-cols-2 mt-3 lg:gap-5 md:gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
        <div v-for="(value, index) in workInfoArray" :key="value.id">
          <ShowProjectCardVue
            :id="value.id"
            :project-name="value.work_name"
            :project-type="value.work_type"
            :url="value.work_cover_url"
            :create-time="value.work_created_time"
            :work_watch_count="value.work_watch_count"
            :work_introduce="value.work_introduce"
            :user_school="value.user_school"
            open-mode="modal"
            @open="openWorkDetail"
          />
        </div>
      </div>
      <div v-else class="flex flex-col items-center justify-center">
        <el-empty description="作品内容为空" image="/img/empty.png" :image-size="44" />
        <el-button type="primary" size="small" @click="refreshWindowLocation">刷新</el-button>
      </div>

      <WorkDetailDialog v-model="detailVisible" v-model:activeId="activeWorkId" :works="workInfoArray" />
    </div>
    <!-- <div class="fixed right-[10%] bottom-[15%]">
      <AIElementX v-if="windowWidth > 768"></AIElementX>
    </div> -->
  </div>
</template>

<script lang="ts" setup>
import ShowClassCardVue from '../LivingClassVue/components/ShowClassCard.vue'
import ShowProjectCardVue from '../Gallery/components/ShowProjectCard.vue'
import WorkDetailDialog from '~/components/Gallery/WorkDetailDialog.vue'
import { useHeaderCurrentIndex } from '~/stores/header/headerCurrentIndex'
import { useLoginInfo } from '~/stores/user/loginInfo'
import { ElLoading } from 'element-plus'

export interface ClassInfoArray {
  id: number
  course_name: string
  course_cover_url: string
  course_introduce: string
  who_can_watch: number
  rank_name: string
  tag_name: string
  course_created_time: string
  watch_count: number
  platform_comment: string
}

export interface WorkList {
  id: number
  user_school: string
  work_name: string
  work_cover_url: string
  work_type: number
  work_created_time: string
  work_watch_count: number
  work_introduce: string
}

const loginInfo = useLoginInfo()
let windowWidth = 0

const router = useRouter()
const currentIndexStore = useHeaderCurrentIndex()

// const getClassArray = (body: any) => {
//     return httpRequest.post(RequestAPI.GET_CLASS_ARRAY, body);
// }

//网络请求获取图片,课程名称，课时，类别， id
var classInfoArray = ref<ClassInfoArray[]>([])
var workInfoArray = ref<WorkList[]>([])

const loading = ref(true)
const detailVisible = ref(false)
const activeWorkId = ref<number>()

const projectArray = reactive([
  {
    id: 1,
    url: '/img/project_1.png',
    projectName: '记忆大师',
    grade: 7,
    projectType: 0,
  },
  {
    id: 2,
    url: '/img/project_2.png',
    projectName: 'AR 元素周期表',
    grade: 8,
    projectType: 1,
  },
  {
    id: 3,
    url: '/img/project_3.png',
    projectName: '找回足球',
    grade: 8,
    projectType: 2,
  },
  {
    id: 4,
    url: '/img/project_4.png',
    projectName: 'Snap Card',
    grade: 7,
    projectType: 1,
  },
])

//点击更多跳转路由
function routeToMoreClass() {
  currentIndexStore.updateCurrentIndex(2)
  router.push('/liveClass')
}

function routeToMoreWork() {
  currentIndexStore.updateCurrentIndex(3)
  router.push('/projectGallery')
}

async function getClassArray() {
  try {
    await nextTick()
    console.log('loginInfo ===', loginInfo)
    const obj = {
      url: RequestAPI.GET_CLASS_ARRAY,
      body: {
        page: 1,
        size: 8,
        platform: loginInfo.platform,
      },
    }

    const response = await postRequired(obj) // 等待请求完成并获取响应结果
    const { data, status } = response
    if (data && data.value) {
      // 先判断data存在且有value属性
      if (status.value === 'success') {
        const listData = data.value.data && data.value.data.list // 安全获取课程列表数据
        if (listData) {
          // 再次判断课程列表数据存在
          classInfoArray.value = listData
        }
      }
    }
  } catch (error) {
    console.error('获取课程列表出错:', error)
    // 根据具体情况，可以选择重新发送请求或进行其他处理
  }
}

//请求获取作品列表
async function getWorkList() {
  try {
    await nextTick()
    const obj = {
      url: RequestAPI.GET_WORK_LIST,
      body: {
        page: 1,
        size: 8,
      },
    }

    const response = await postRequired(obj) // 等待请求完成并获取响应结果
    const { data, status } = response
    if (data && data.value) {
      // 先判断data存在且有value属性
      if (data.value.code === 2000) {
        const listData = data.value.data && data.value.data.workList // 安全获取课程列表数据
        if (listData) {
          // 再次判断课程列表数据存在
          workInfoArray.value = listData
        }
      }
    }
  } catch (error) {
    console.error('获取作品列表出错:', error)
    // 根据具体情况，可以选择重新发送请求或进行其他处理
  }
}

onMounted(() => {
  getClassArray()
  getWorkList()
  windowWidth = window.innerWidth
})

const openWorkDetail = ({ id }: { id: number }) => {
  activeWorkId.value = id
  detailVisible.value = true
}
</script>

<style></style>
